import React from "react";
import ChangePassword from "../components/Password";

function PasswordReset() {
    return (
      <>
        <ChangePassword />
      </>
    );
  };
  
export default PasswordReset;